import {Avatar, Button, Card, Col, Dropdown, Menu, notification, Popconfirm, Row, Space, Tag, Typography} from "antd";
import React, {Fragment} from "react";
import ModalAddCom from "./ModalAddCom";
import {DownOutlined, MinusCircleOutlined, MoreOutlined} from "@ant-design/icons";
import {checkForfait, checkPermissions} from "../../../components/permissions/functions";
import IntlMessage from "../../../components/util-components/IntlMessage";
import ApiService from "../../../services/ApiService";
import moment from "moment";
import {connect} from "react-redux";

const {Text} = Typography

class CardCom extends React.Component {

    async onDelete() {
        const {contact, item, onChange} = this.props

        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        await ApiService.post("/contact/commentaire/delete/" + item.id + "/" + contact)

        if (onChange) {
            onChange()
        }

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    renderAccessAvatar(access) {
        const org = this.props.org

        let bgColor = "#000"
        let shortName = access?.prenom.slice(0, 3).toUpperCase()

        const _access = org.accessList.find(i => i.id === access.id)
        if (_access && _access.shortName) {
            shortName = _access.shortName
        }
        if (_access && _access.color) {
            bgColor = _access.color
        }

        return (
            <Avatar size="small" style={{backgroundColor: bgColor, color: "#FFF"}}>{shortName}</Avatar>
        )
    }

    render() {
        const {contact, item, editable, onChange} = this.props

        var MENU = [
            {
                key: "0",
                label: (
                    <a onClick={() => this.modalAddCom.show(contact, item)}><Text type={"secondary"}>Modifier</Text></a>
                )
            },
            {
                key: "1",
                label: (
                    <Popconfirm
                        title="Êtes-vous sûrs de vouloir supprimer cette activité ?"
                        onConfirm={() => this.onDelete()}
                        okText="Oui"
                        cancelText="Non"
                        okType={"danger"}
                    >
                        <Text type={"danger"}>Supprimer</Text>
                    </Popconfirm>
                )
            }
        ]


        return (
            <Fragment>
                <Card
                    title={(
                        <Fragment>
                            <Tag color="magenta">{item.type}</Tag>
                            {item.accessId && (
                                <Tag color="processing">{item.accessPrenom} {item.accessNom}</Tag>
                            )}
                            {item.access && this.renderAccessAvatar(item.access)}
                        </Fragment>
                    )}
                    extra={editable && (
                        <Dropdown overlay={
                            <Menu
                                items={MENU}
                            />
                        } trigger={['click']}>
                            <a onClick={(e) => e.preventDefault()}>
                                <Button type={"text"} icon={<MoreOutlined/>}/>
                            </a>
                        </Dropdown>
                    )}
                >

                    {Array.isArray(item.actions) && item.actions.length > 0 && (
                        <Row style={{gap: 5, marginBottom: 20}}>
                            {item.actions.map((i, k) => {
                                return (
                                    <Tag key={k} color="lime">{i}</Tag>
                                )
                            })}
                        </Row>
                    )}

                    <Col>
                        <Text type={"primary"}>{item.content}</Text>
                    </Col>

                    <Col style={{display: "flex", justifyContent: "flex-end"}}>
                        <Text type={"secondary"}>{moment(item.datetime).format("dddd DD MMMM YYYY à HH:mm")}</Text>
                    </Col>

                </Card>
                <ModalAddCom getRef={(ref) => this.modalAddCom = ref} onFinish={() => {
                    if (onChange) {
                        onChange()
                    }
                }}/>
            </Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        org: state.auth.org
    }
};

export default connect(mapStateToProps)(React.memo(CardCom));
